module.exports = __webpack_public_path__ + "media/Video 20.683d56b3.mp4";